<template>
  <fragment>
    <Hero />
    <HowItWorks />
    <Video />
    <Examples />
    <SpecificUses />
    <Signup
      :data="{
        title: 'Join the all-in-one video and filmmakers platform today.',
        subtitle: 'Create your best work without the hassle of messy license restrictions.'
      }"
    />
  </fragment>
</template>

<script>
/* components */
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import Video from "./components/Video";
import Examples from "./components/Examples";
import SpecificUses from "./components/SpecificUses";
import Signup from "./components/Signup";

export default {
  components: {
    Hero,
    HowItWorks,
    Video,
    Examples,
    SpecificUses,
    Signup,
  },
  metaInfo: () => ({
    title: "License | Motion Array",
    link: [
      { rel: "stylesheet", href: "https://vjs.zencdn.net/7.7.6/video-js.css" },
      { rel: "stylesheet", href: "/assets/site/css/license.css" }
    ],
    script: [
      { src: "https://vjs.zencdn.net/7.7.6/video.js", body: true }
    ],
  }),
};
</script>
